import { Routes } from '@angular/router';
import { AppPage, LazyModuleConfig, AgCheckBoxEditor } from 'jk-service';

export const moduleConfigs: LazyModuleConfig[] = [
  {
    path: 'mtr',
    loadChildren: () => import('mtr').then(m => m.MtrModule),
    preload: true,
    priority: 1
  },
  {
    path: 'uty',
    loadChildren: () => import('uty').then(m => m.UtyModule),
    preload: true,
    priority: 1
  },
  {
    path: 'sys',
    loadChildren: () => import('sys').then(m => m.SysModule),
    preload: true,
    priority: 1
  }
];

export const appPages: AppPage[] = [
  { title: '首頁', url: '/home', icon: 'home', id: 'home', isCheckPower: false, checked: true, hint: '一切從家開始' },
  { title: '問題反應單', url: '/mtrki02', icon: 'receipt', id: 'mtrki02', isCheckPower: true, checked: true, hint: '問題反應單' },
  { title: '電腦/IP建立', url: '/utyji05', icon: 'receipt', id: 'utyji05', isCheckPower: true, checked: true, hint: '電腦/IP建立' },

];

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./components/home/support-home.component').then(m => m.SupportHomeComponent),
  },
  {
    path: 'home',
    loadComponent: () => import('./components/home/support-home.component').then(m => m.SupportHomeComponent),
  },
  {
    path: 'mtr',
    loadChildren: () => import('mtr').then(m => m.MtrModule),
    data: { preload: true, priority: 1, preloadDelay: 0 }
  },
  {
    path: 'uty',
    loadChildren: () => import('uty').then(m => m.UtyModule),
    data: { preload: true, priority: 1, preloadDelay: 0 }
  },
  {
    path: 'sys',
    loadChildren: () => import('sys').then(m => m.SysModule),
    data: { preload: true, priority: 1, preloadDelay: 0 }
  },
  {
    path: '**',
    redirectTo: 'home',
  },
];
